import React from "react";
import { Box } from "@mui/material";
import {
  AccountBalance as FinanceIcon,
  PaymentsOutlined as CollectionsIcon,
  TollOutlined as TokenIcon,
} from "@mui/icons-material";
import useAuth from "../../hooks/useAuth";
import { useHasPermission } from "../../hooks/useHasPermission";
import { useClinicModule } from "../../hooks/useClinicModule";
import { COLORS, CARD_PAGE_PAD } from "../../styles/uiConstants";
import { TabbedPageShell } from "../../components/organisms";
import FinancialTab from "../BusinessPerformance/FinancialTab";
import CollectionsTab from "./CollectionsTab";

// Finansal: "Tahsilat" (kliniğin hastadan aldığı ödemeler — billing modülü,
// payments:read) + "Pupill Kullanımı" (token bakiyesi — finance:read).
export default function Financial() {
  const { auth } = useAuth();
  const token = auth?.accessToken;
  const canPayments = useHasPermission("payments:read");
  const billingActive = useClinicModule("billing");
  const canFinance = useHasPermission("finance:read");

  const tabs = [
    canPayments && billingActive && {
      key: "tahsilat",
      label: "Tahsilat",
      icon: <CollectionsIcon sx={{ fontSize: 18 }} />,
    },
    canFinance && { key: "pupill", label: "Pupill Kullanımı", icon: <TokenIcon sx={{ fontSize: 18 }} /> },
  ].filter(Boolean);

  return (
    <TabbedPageShell
      icon={<FinanceIcon sx={{ fontSize: 22 }} />}
      title="Finansal"
      subtitle="Hastalardan yapılan tahsilat ve Pupill token kullanımı"
      tabs={tabs}
    >
      {(tab) =>
        tab === "tahsilat" ? (
          <CollectionsTab token={token} />
        ) : (
          // Kartlı analiz sayfası (design-principles §4): slate50 zemin, başlık şeridi hizası
          <Box sx={{ flex: 1, minHeight: 0, overflowY: "auto", bgcolor: COLORS.slate50, ...CARD_PAGE_PAD }}>
            {canFinance ? <FinancialTab token={token} /> : null}
          </Box>
        )
      }
    </TabbedPageShell>
  );
}
